var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestKeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#CCCCCC;}\n\t.st3{fill:#F79422;}\n\t.st4{opacity:0.1;}\n\t.st5{fill:none;}\n\t.st6{fill:#B3B3B3;}\n\t.st7{fill:#8F4D38;}\n\t.st8{fill:#EF5350;}\n\t.st9{fill:#C02E1D;}\n\t.st10{clip-path:url(#SVGID_2_);fill:#E4C05C;}\n\t.st11{fill:#DDA86F;}\n\t.st12{fill:#BC9C4D;}\n\t.st13{clip-path:url(#SVGID_4_);fill:#E4C05C;}\n\t.st14{fill:#8CC63F;}\n\t.st15{fill:#7AC943;}\n\t.st16{opacity:0.1;fill:#39B54A;}\n\t.st17{fill:#E4C05C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M18.5,13.8c1.9-3.7,1.8-7.8-1.3-10.9C13.1-1.2,6.4-1,2.6,3.5c-3.3,3.9-3,9.8,0.6,13.4c2.8,2.7,6.6,3.3,10,2.1 l1.7,1.8h3.1v2.5h2.5v2.5h3.1v3.1h1.9v1.7c0,0.5,0,0.6,0.3,1c0.2,0.2,0.6,0.4,0.9,0.4h4.9v-5.6L18.5,13.8z M9.7,9.5 c-1.2,1.2-3.2,1.2-4.4,0c-1.2-1.2-1.2-3.2,0-4.4c1.2-1.2,3.2-1.2,4.4,0C10.9,6.3,10.9,8.3,9.7,9.5L9.7,9.5z M9.7,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M16.9,16.5l-3.5,2.7l1.6,1.6h3.1v2.5h2.5v2.5h3.1v3.1h1.9v1.7c0,0.5,0,0.6,0.3,1c0.2,0.2,0.6,0.4,0.9,0.4h5 v-0.6L16.9,16.5z M16.9,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M7.6,2.9c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3C11.9,4.9,10,2.9,7.6,2.9 L7.6,2.9z M7.6,10.4c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1C10.7,9,9.3,10.4,7.6,10.4L7.6,10.4z  M7.6,10.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestKeys);
export default __webpack_public_path__ + "static/media/request_keys.dd155365c65b74ec12bb920d15f453ae.svg";
export { ForwardRef as ReactComponent };